import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SCOPE_STATEMENT } from "@/lib/content";

export const Closing = () => (
  <section className="relative bg-forest py-20 sm:py-36 overflow-x-clip overflow-hidden" data-testid="closing-section">
    <div aria-hidden className="pointer-events-none absolute -right-24 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-white/[0.04]" />
    <div className="container-x relative grid lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-8">
        <h2 className="h-display !text-white max-w-3xl" data-testid="closing-heading">Know more about the place<br className="hidden sm:block" /> you call home.</h2>
        <p className="lead !text-white/85 mt-6 max-w-xl" data-testid="closing-supporting">In-home air and water testing. Clear findings. Practical next steps.</p>
      </div>
      <div className="lg:col-span-4 lg:text-right">
        <Link to="/book" className="btn-primary !bg-white !text-forest hover:!bg-mint sm:px-8" data-testid="closing-book-cta">Book your assessment <ArrowRight size={18} /></Link>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="bg-[#0F2A22] text-white border-t border-white/15" data-testid="site-footer">
    <div className="container-x py-14 sm:py-16 grid gap-10 md:grid-cols-12">
      <div className="md:col-span-5">
        <p className="text-base font-bold uppercase tracking-[0.26em]">Unseen</p>
        <p className="mt-1 font-serif italic text-lg text-white/70">Home Health Lab</p>
        <p className="mt-6 text-sm text-white/70" data-testid="footer-location">Upper East Side, NYC.</p>
      </div>
      <div className="md:col-span-7 md:pl-8">
        <p className="mono uppercase tracking-[0.18em] text-white/70">Scope</p>
        <p className="mt-3 text-sm sm:text-[15px] leading-relaxed text-white/80 max-w-xl" data-testid="footer-scope">{SCOPE_STATEMENT}</p>
        <nav className="mt-8 flex flex-wrap gap-x-7 gap-y-1 text-sm text-white/70" aria-label="Footer">
          <a href="/#what-we-test" className="hover:text-white inline-flex items-center min-h-[44px]">What we test</a>
          <a href="/#how-it-works" className="hover:text-white inline-flex items-center min-h-[44px]">How it works</a>
          <a href="/#pricing" className="hover:text-white inline-flex items-center min-h-[44px]">Pricing</a>
          <a href="/#faqs" className="hover:text-white inline-flex items-center min-h-[44px]">FAQs</a>
        </nav>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x py-5 flex flex-col sm:flex-row gap-2 sm:items-center justify-between text-xs text-white/70">
        <p>© {new Date().getFullYear()} UNSEEN — Home Health Lab.</p>
        <p>Photography is representative and not of client homes.</p>
      </div>
    </div>
  </footer>
);
